module.exports = __webpack_public_path__ + "img/5. HOMECARE, CAREPASS.jpg";